export default {
      id: "circle-usage",
      viewBox: "0 0 16 16",
      url: "../../assets/" + "sprite.svg#circle-usage",
      toString: function () {
        return this.url;
      }
    }